import { DateUtils } from '@spotify/confidence-core-react';

import { useChatContext } from '../ChatThread/ChatContext';

import styles from './AssistantMessage.module.css';

interface MessageTimestampProps {
  eventName: string;
}

export const MessageTimestamp = ({ eventName }: MessageTimestampProps) => {
  const event = useChatContext()?.chatEvents.find(e => e.name === eventName);
  const formatted = event
    ? DateUtils.toDateString(event.createTime, DateUtils.TIME_FORMAT)
    : undefined;

  if (!formatted) return null;

  return <span className={styles.messageTimestamp}>{formatted}</span>;
};
